module.exports = __webpack_public_path__ + "static/media/shape1_4.25bff1f1.obj";